// import contact from './Contact'
import image from "./Image";
import instance from "./Instance";
import job from "./Job";
import company from "./Company";
import exhibitionWork from "./ExhibitionWork";

const ListItems = ({ item = false } = {}) => `
  id
  ${
    item
      ? `item {
      __typename
      ... on Artist {
        id
        name
        bornCountry {
          name
        }
        confidential
      }
      ... on Artwork {
        id
        imagesSummary {
          imgT
          imgX
        }
        artists {
          name
        }
        title
        description
        medium
        dimensions
      }
      ... on Contact {
        id
        companyName: company
        country {
          id
          name
        }
        county
        email
        img
        name
        salesUser {
          id
          name
        }
        title
        type {
          id
          name
        }
      }
      ... on Company {
        ${company(item)}
      }
      ... on Exhibition {
        id
        artFair
        contact {
          company
          name
        }
          exhibitionWorks {
            ${exhibitionWork(item)}
          }
        endDay
        endMonth
        endYear
        startDay
        startMonth
        startYear
        title
      }
      ... on Image {
        ${image(item)}
      }
      ... on Instance {
        ${instance(item)}
      }
      ... on Invoice {
        id
        date
        company {
          name
        }
        type {
          id
          description
        }
        approved
        contact {
          name
          img
        }
        companyName
        number
        reference
        currency {
          code
        }
        invoiceTotals
        dueDate
      }
      ... on Offer {
        id
        artwork {
          id
          title
          artists {
            name
          }
          imagesSummary {
            imgT
          }
        }
        contactId
        holdId
        updatedAt
        date
        status {
          id
          description
        }
        statusId
        currency {
          id
          code
        }
        amount
        currencyId
        tbiAmount
        dateClosed
        user
      }
      ... on WarehouseItem {
        id
        category {
          description
        }
        description
        destroyed
        weightType {
          id
          name
        }
        weight
      }
      ... on Job {
        ${job(item)}
      }
      ... on Reservation {
        id
        categoryId
        type {
          description
        }
        date
        dateDue
        reservationUser {
          name
        }
        createdBy {
          name
        }
        reservationInstanceCount
      }
    }`
      : ""
  }
  listId
  meta
`;

export default ListItems;
